export class ScaleIn {
    /**
        * Class constructor *
        * @arg {object} - `els` check for the page elements array on load.
    **/
    constructor (els) {
        if (!els.length > 0) return;
        this.els = els;
        this.init();
    }

    init() {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.remove('scale-in');
                        observer.unobserve(entry.target);
                        entry.target.addEventListener('transitionend', this.handleTransitionEnd);
                    }
                });
            }, {
                threshold: 0.3 // Trigger when 30% of the element is visible
            });
            
            this.els.forEach(el => {
                observer.observe(el);
            });
        } else {
            this.els.forEach(el => {
                el.classList.remove('scale-in');
            });
        }
    }

    // On transition end remove js scale class. Class houses transition settings
    handleTransitionEnd (event) {
        event.target.classList.remove('js-scale-in');
    }
}
